export enum CancelTxReason {
  Default = '100',
  AgentDefault = '200',
  IDCardCheckFailure = '101',
}
